import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#333",
  "fill-rule": "evenodd",
  d: "M1.578 11.217c0 5.31 4.24 9.614 9.469 9.614 5.23 0 9.469-4.305 9.469-9.614s-4.24-9.615-9.47-9.615c-5.229 0-9.468 4.305-9.468 9.615M11.047 0C4.946 0 0 5.022 0 11.217s4.946 11.216 11.047 11.216c6.1 0 11.047-5.021 11.047-11.216S17.148 0 11.047 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#333",
  "fill-rule": "evenodd",
  d: "m24.326 27.434-7.811-7.932 1.116-1.133 7.81 7.931a.81.81 0 0 1 0 1.133.78.78 0 0 1-1.115 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }